// Builds a human-readable "typing" sentence from the list of people currently
// typing in a conversation, Slack-style:
//   ['Ali']                      -> 'Ali is typing'
//   ['Ali', 'Sam']               -> 'Ali and Sam are typing'
//   ['Ali', 'Sam', 'Jo']         -> 'Ali, Sam, and Jo are typing'
//   ['Ali', 'Sam', 'Jo', 'Lee']  -> 'Ali, Sam, and 2 others are typing'
//
// maxNames caps how many names are listed before collapsing to "N others",
// which keeps the label from overflowing in tight spots like the sidebar.
export const formatTypingNames = (names: string[], maxNames = 2): string => {
	const unique = Array.from(new Set(names.filter(Boolean)));

	if (unique.length === 0) {
		return '';
	}

	const verb = unique.length === 1 ? 'is' : 'are';

	let subject: string;

	if (unique.length === 1) {
		[subject] = unique;
	} else if (unique.length === 2) {
		subject = `${unique[0]} and ${unique[1]}`;
	} else if (unique.length <= maxNames + 1) {
		// few enough to list everyone with an Oxford comma
		subject = `${unique.slice(0, -1).join(', ')}, and ${
			unique[unique.length - 1]
		}`;
	} else {
		const shown = unique.slice(0, maxNames).join(', ');
		const others = unique.length - maxNames;
		subject = `${shown}, and ${others} other${others === 1 ? '' : 's'}`;
	}

	return `${subject} ${verb} typing`;
};
